import { getAppEnv, waitForAppEnvInit } from '../../env/browser/env.js';
import { Ok } from '../../result/shared/result.js';
import { PrettyFormatter } from '../shared/Formatter/PrettyFormatter.js';
import { LogLevel } from '../shared/Log/ILog.js';
import { Logger } from '../shared/Logger/Logger.js';
import { createBaseStdoutLogger } from './baseStdoutLogger.js';
import { ELKFormatter } from './Formatter/ELKFormatter.js';
import { ConsoleTransport } from './Transport/ConsoleTransport.js';
import { HTTPTransport } from './Transport/HTTPTransport.js';

/**
 * Создает контекстный логгер с привязкой к `AppEnv`. Если контекст не инициализирован,
 * то возвращает ошибку
 *
 * @export
 * @param {string} name - имя workspace, оно необходимо для управления уровнем логирования
 * @param {Options} [opts]
 * @return {GenericErrResult<Logger>}
 */
function createContextLogger(name, opts) {
    const appEnv = getAppEnv();
    if (appEnv.isErr()) {
        return appEnv;
    }
    const transport = makeContextTransport(appEnv.Ok, name, opts);
    const logger = new Logger({
        transport,
        name,
        filter: opts?.filter,
        level: opts?.level,
    });
    if (opts?.debugEnabled) {
        logger.level = LogLevel.Debug;
    }
    return Ok(logger);
}
function makeContextTransport(appEnv, name, opts) {
    let formatter;
    let transport;
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        formatter = new PrettyFormatter(name);
        transport = new ConsoleTransport(formatter);
    }
    else {
        formatter = new ELKFormatter(appEnv);
        transport = opts?.url ? new HTTPTransport(formatter, new URL(opts.url)) : new ConsoleTransport(formatter);
    }
    return transport;
}
/**
 * Пробует безопасно создать экземпляр контекстного логгера, если контекст не инициализирован,
 * то создает базовый логгер
 *
 * @export
 * @param {string} name - имя workspace, оно необходимо для управления уровнем логирования
 * @param {Options} [opts]
 * @return {Logger}
 */
function tryCreateContextLogger(name, opts = {}) {
    const { waitForContext = true } = opts;
    return createContextLogger(name, opts).unwrapOrElse(() => {
        const logger = createBaseStdoutLogger(name, opts);
        if (waitForContext) {
            // TODO: Потенциально здесь могут быть утечки памяти. К моменту инициализации appEnv
            // logger может уже не использоваться (то есть должен быть удален из памяти)
            waitForAppEnvInit(() => {
                logger.setTransport(makeContextTransport(getAppEnv().unwrap(), name, opts));
            });
        }
        return logger;
    });
}

export { createContextLogger, makeContextTransport, tryCreateContextLogger };
//# sourceMappingURL=logger.js.map
